import { FC } from "react";
import { OnboardingRequestDto } from "../../../api/Api";
import { MyOnboardingRequestsGrid } from "../../../components/onboardingRequests/myRequestsGrid";
import { OnboardingRequestBook } from "../../../components/onboardingRequests/types";
import { useMyOnboardingRequests } from "../../admin/onboardingRequests/queries";

const counterpartyBook: OnboardingRequestBook<OnboardingRequestDto> = {
  entityLabel: "Counterparty",
  entityName: (row) => row.payload?.counterpartyName ?? "",
  resultingEntityId: (row) => row.resultingCounterpartyId,
  entityPath: (id) => `/tradingcounterparties/counterparty/${id}`
};

export const MyOnboardingRequests: FC = () => (
  <MyOnboardingRequestsGrid
    book={counterpartyBook}
    useMyRequests={useMyOnboardingRequests}
  />
);
